<section class="words-strip" aria-label="Valores de Aruma">
  <div class="words-strip__track" #track>
    @for (copy of stripCopies; track copy) {
      <div
        class="words-strip__set"
        [attr.aria-hidden]="copy > 0 ? 'true' : null"
      >
        @for (item of stripItems; track $index) {
          <div class="words-strip__box">
            <span class="words-strip__word">{{ item.word }}</span>
          </div>
          <img
            [src]="'images/' + item.icon"
            class="words-strip__icon"
            [width]="item.iconWidth ?? 32"
            [height]="item.iconHeight ?? 32"
            alt=""
            aria-hidden="true"
          />
        }
      </div>
    }
  </div>
</section>
